import { render, staticRenderFns } from "./CoreProgramPage.vue?vue&type=template&id=bd9a48d4&"
import script from "./CoreProgramPage.vue?vue&type=script&lang=js&"
export * from "./CoreProgramPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports